<template>
  <vxe-modal v-model="visible" :destroyOnClose="true" :loading="loading" :title="$t('business.label.address')+$t('button.edit')" show-footer size="mini" type="confirm" width="60%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="address" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.company')">
            <a-input v-model="address.contactInfo.company" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.contactor')">
            <a-input v-model="address.contactInfo.contactor" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.phone')">
            <a-input v-model="address.contactInfo.phone" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.email')">
            <a-input v-model="address.contactInfo.email" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.idType')">
            <a-select v-model="address.contactInfo.idType" :options="idTypes" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.idNumber')">
            <a-input v-model="address.contactInfo.idNumber" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.country')">
            <a-input v-model="address.addressInfo.country" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.province')">
            <a-input v-model="address.addressInfo.province" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.city')">
            <a-input v-model="address.addressInfo.city" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.district')">
            <a-input v-model="address.addressInfo.district" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.town')">
            <a-input v-model="address.addressInfo.town" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.village')">
            <a-input v-model="address.addressInfo.village" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.street')">
            <a-input v-model="address.addressInfo.street" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.postalCode')">
            <a-input v-model="address.addressInfo.postalCode" allowClear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="16">
          <a-form-model-item :label="$t('business.label.detailAddress')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-textarea v-model="address.addressInfo.detailAddress" :autosize="{ minRows: 2 }"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.direction')">
            <a-select v-model="address.direction.name" :options="directions" allowClear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col :span="16">
          <a-form-model-item :label="$t('business.label.customer')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <a-textarea v-model="customerNames" autoSize readOnly @dblclick="onCustomerSelect" @pressEnter="onCustomerSelect"/>
            <customer-modal ref="customerModal" select-type="checkbox" @change="onCustomerChange"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { Address } from '@/api/dto/common/Address'
import CustomerModal from '@/views/modal/CustomerModal.vue'
import { getStrings } from '@/utils/util'

export default {
  name: 'AddressEditor',
  components: { CustomerModal },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      visible: false,
      loading: false,
      address: new Address(),
      customers: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    }
  },
  props: {
    directions: {
      type: Array,
      default: []
    },
    idTypes: {
      type: Array,
      default: []
    }
  },
  computed: {
    customerNames() {
      return getStrings(this.customers, 'name')
    }
  },
  methods: {
    onCustomerSelect() {
      this.$refs.customerModal.open({ available: true, downstream: true }, null, this.customers)
    },
    onCustomerChange(data) {
      this.customers = data
    },
    add() {
      this.visible = true
      this.address = new Address()
      this.onCustomerChange()
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('addressFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.address = new Address(res.result)
          this.onCustomerChange(res.result.customers)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const address = this.address.toJSONObject()
      address.enterprise = this.enterprise
      address.customers = this.customers.map(item => {
        return { id: item.id, name: item.name }
      })
      save('addressPersister', address).then(res => {
        if (res.success) {
          this.address = new Address()
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>